/**
 * billing.js — API wrappers for the Billing screen.
 *
 * Backend surface (verified against app/main.py @ /api/my/billing/topup):
 *   - POST /api/my/billing/topup  { amount: int }
 *       → { status: "ok", added: int }
 *       Mock payment gateway; adds tokens to the tenant balance immediately
 *       when ALLOW_MOCK_TOPUP=1 on the server. No `payment_url` comes back
 *       yet — when the real ЮKassa flow lands, the backend is expected to
 *       return { payment_url: "..." } and this client will follow it.
 *
 * The balance itself lives on /api/my/config as `tokens_balance`, same as the
 * legacy dashboard. We expose `getMyConfig` here as a convenience so Billing
 * doesn't have to import from api/settings.js (keeps M3-A surface narrow —
 * see bar on cross-screen imports in docs/react-migration/01-scope.md).
 *
 * History / documents / requisites have no backend yet; those screens render
 * mock data from utils/mocks/billing.js with an inline TODO banner.
 */

import { apiFetch } from './client';

export async function topup(amount) {
  const parsed = Number(amount);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    throw new Error('Сумма должна быть положительным числом');
  }
  return apiFetch('/my/billing/topup', {
    method: 'POST',
    body: { amount: Math.round(parsed) },
  });
}

/**
 * Pulls the current widget config. We only care about `tokens_balance` here
 * but the helper returns the raw payload so callers can decide what else to
 * read (company_name, site_slug).
 */
export async function getMyConfig(siteSlug = null) {
  return apiFetch('/my/config', {
    headers: siteSlug ? { 'X-Site-Slug': siteSlug } : undefined,
  });
}
